import { CvssVersion, type Cvss40SupplementalValues } from '../cvss-enums';
import { CvssScore } from '../cvss-score';

/**
 * Represents a CVSS 4.0 score produced by an instance of {@link CvssScoringEngine}.
 *
 * @public
 */
export class Cvss40Score extends CvssScore {
    /**
     * Initializes a new instance of a CVSS score.
     *
     * @param baseScore - the base score
     * @param environmentalScore - the environmental score
     * @param overallScore - the overall score (non-standard addition by NIST/NVD)
     * @param threatScore - the threat score
     * @param supplementalValues - the values of the CVSS v4.0 supplemental components
     * @param supported - the score is supported by the CVSS version used to compute it
     */
    public constructor(
        baseScore = 0, // All CVSS
        environmentalScore: number | null = null, // All CVSS
        overallScore = 0, // All CVSS
        threatScore: number | null = null, // CVSS v4
        supplementalValues: Cvss40SupplementalValues = {} as Cvss40SupplementalValues,
        supported = true,
    ) {
        super(
            CvssVersion.CVSS40,
            baseScore,
            null,
            null,
            null,
            environmentalScore,
            null,
            overallScore,
            threatScore,
            supported,
        );

        this._supplementalValues = supplementalValues;
    }

    /**
     * Gets the supplemental metrics with convenient access to full names
     */
    get supplemental(): Cvss40SupplementalValues {
        return this._supplementalValues;
    }
    private _supplementalValues: Cvss40SupplementalValues;
}
